import { render, staticRenderFns } from "./ChartFrame.vue?vue&type=template&id=2d8960f8&"
import script from "./ChartFrame.vue?vue&type=script&lang=js&"
export * from "./ChartFrame.vue?vue&type=script&lang=js&"
import style0 from "./ChartFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports